import React from 'react';

export default function ShipmentsTable() {
	return (
		<div className="table-view table-responsive">
			<table id="shipments-table" className="table">
				<thead>
					<tr>
						<th>Shipment Number</th>
						<th>Dispatch Date</th>
						<th>Tracking Number </th>
						<th>Shipping Company</th>
						<th>Comments</th>
						<th>Status</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
